import React, { useEffect, useState, lazy, Suspense, memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import Loading from 'components/shared-components/Loading';
import { useTheme } from 'context/ThemeContext';
import { resolveThemeConfig, getThemeScopedStyles } from 'theme/themes';
// import { resources } from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes';
import SystemContext from 'context/SystemContext';
import navigationConfig from 'configs/NavigationConfig';
import homeConfig from 'configs/HomeConfig';
import { useLocation } from 'react-router-dom';
import { utilLanguageService } from 'services/UtilLanguageService';
import { onLocaleChange } from 'store/slices/themeSlice';
import i18next from 'i18next';
import ThemeEffectManager
    from 'theme/effects/ThemeEffectManager';

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
    const { theme } = useTheme();
    const token = useSelector((state) => state.auth.token);
    const blankLayout = useSelector((state) => state.theme.blankLayout);
    const locale = useSelector((state) => state.theme.locale);
    let location = useLocation()
    const dispatch = useDispatch();

    const Layout = token && !blankLayout ? AppLayout : AuthLayout;
    const direction = useSelector((state) => state.theme.direction);

    useBodyClass(`dir-${direction}`);

    useEffect(() => {
        const fetchLanguage = async () => {
            const res = await utilLanguageService.getAll({query: `isd:1`});
            if (res?.data?.length > 0) {
                // setLocales(res.data[0].code);
                dispatch(onLocaleChange(res.data[0].code));
                i18next.changeLanguage(res.data[0].code);
                localStorage.setItem('i18nextLng', res.data[0].code);
                localStorage.setItem('version', JSON.stringify({ init: true }));
            }
        }
        const version = JSON.parse(localStorage.getItem('version') ?? '{}');
        if (!version || !version?.init) {
            fetchLanguage();
        }
    }, []);

    const themeConfig = useMemo(() => resolveThemeConfig(theme), [theme]);
    const themeScopedStyles = useMemo(() => getThemeScopedStyles(theme), [theme]);

    useEffect(() => {
        const token = themeConfig?.token ?? {};
        const pageBg = token.moduleMenuBg ?? token.colorPrimary;
        const inCardBg =
            token.bodyBg ?? token.colorBgLayout ?? token.moduleMenuBg ?? token.colorPrimary;
        const color = token.moduleMenuItemColor ?? token.colorTextLightSolid ?? '#ffffff';
        if (pageBg) {
            document.documentElement.style.setProperty('--detail-theme-action-bg', pageBg);
        }
        if (inCardBg) {
            document.documentElement.style.setProperty('--detail-theme-action-in-card-bg', inCardBg);
        }
        if (color) {
            document.documentElement.style.setProperty('--detail-theme-action-color', color);
            document.documentElement.style.setProperty('--detail-theme-action-in-card-color', color);
        }
    }, [themeConfig]);

    const [navItems, setNavItems] = useState(homeConfig);
    const [parentNav, setParentNav] = useState(navigationConfig);
    
    // useEffect(() => {
    //     // if(location.pathname === '/') {
    //         setNavItems(homeConfig);
    //         setParentNav(navigationConfig);
    //     // }
    // },[location])

    return (
        <ConfigProvider theme={themeConfig} direction={direction} locale={locale}>
            {themeScopedStyles ? <style>{themeScopedStyles}</style> : null}
            <SystemContext.Provider value={{navItems, setNavItems, parentNav,setParentNav}}>
                <Suspense fallback={<Loading cover="content" />}>
                    <ThemeEffectManager />
                    <Layout>
                        <Routes />
                    </Layout>
                </Suspense>
            </SystemContext.Provider>
        </ConfigProvider>
    );
};

export default memo(Layouts);
